import { Box } from "@mantine/core";
import type { JSX } from "react";
import { useParams } from "react-router";
import { useQuery } from "urql";
import Loading from "../Loading";
import { type ThreadQuery, type ThreadQueryVariables, threadQuery } from "./queries";
import Thread from "./Thread";

function LoadThread(): JSX.Element {
    const { threadId } = useParams();
    const [threadResult] = useQuery<ThreadQuery, ThreadQueryVariables>({
        query: threadQuery,
        variables: {
            threadId: Number.parseInt(threadId!, 10),
        },
    });

    if (threadResult.fetching) {
        return <Loading />;
    }
    if (threadResult.error) {
        return <Box>Error: {threadResult.error.message}</Box>;
    }
    const thread = threadResult.data?.thread;
    if (!thread) {
        return <Box>Error: Failed to load thread</Box>;
    }
    return <Thread thread={thread!} />;
}

export default LoadThread;
